import React, { useState, useEffect, useRef } from 'react';
import { translate } from '../../../Services/translation';

const CustomDropdown = ({ options, onSelect, selectedValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const handleOptionClick = (value) => {
    onSelect(value);
    setIsOpen(false);
  };

  return (
    <div
      className={`custom-dropdown ${isOpen ? 'dropdown-open' : ''}`}
      onClick={() => setIsOpen(!isOpen)}
      ref={dropdownRef}
    >
      <div className="custom-dropdown__selected-value">
        {selectedValue === '' ? (
          <span className="custom-dropdown__selected-value--placeholder">
            {translate('investment-page-modal-dropdown-placeholder')}
          </span>
        ) : (
          <span className="custom-dropdown__selected-value--value">
            {selectedValue}
          </span>
        )}
      </div>
      <span
        className={`custom-dropdown__arrow ${isOpen ? 'arrow-open' : ''}`}
      ></span>
      {isOpen && (
        <div className="custom-dropdown__options">
          {options.map((option) => (
            <div
              key={option.value}
                  className={`custom-dropdown__option ${selectedValue === option.label
                  ? 'selected-option color-blue'
                  : ''
                      }`}
                  onClick={() => handleOptionClick(option.label)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
